import axios from "axios";

const Portfolio = (state = [], action) => {
  switch (action.type) {
    case "REQUEST_GET":
      return axios.get("http://localhost:3000/Request").then(
        function (res) {
          return (state = res.data);
        }.bind(this)
      );
    case "SET_PORTFOLIO_LIST":
      state.portfolioWorkloadList = action.payload;
      return state;
    case "SET_PORTFOLIO_DETAIL":
      state.portfolioDetail = action.payload;
      return state;
    case "SET_PORTFOLIO_WORKLOAD_TYPE_LIST":
      state.portfolioWorkloadTypeList = action.payload;
      return state;
    case "SET_PORTFOLIO_WORKLOAD_DETAIL_LIST":
      state.portfolioWorkloadDetailList = action.payload;
      return state;
    default:
      return state;
  }
};
export default Portfolio;
